import request from '../utils/fetch'

export function sendSmsYZM (data) {
  return request({
    url: '/aliSms/sendSmsYZM',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function checkoutCode (data) {
  return request({
    url: '/aliSms/checkoutCode',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}